<template>
  <!--空数据-->
  <div class="center-middle-box no-data-wrap">
    <img :src="src" />
    <p>{{ msg }}</p>
  </div>
</template>
<script>
export default {
  props: {
    msg: {
      default: "暂无数据",
    },
    src:{
      default: "/images/emptyData.png"
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  components: {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less">
.no-data-wrap {
  text-align: center;
  img {
    width: 100%;
    max-width: 268px;
  }
  p {
    text-align: center;
    font-size: 14px;
    line-height: 1;
    color: #999;
    margin-top: -10px;
  }
}
</style>
